import React, { useState, useEffect, useRef } from "react";
import AWS from 'aws-sdk';
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil";
import { conversationState , tableLoadingState } from "../../store/atoms";
import { Fragment } from "react";
import ConversationCard from "./ConversationCard";
import { saveAs } from "file-saver";
import { utils, write } from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo, faFileExport, faSpinner, faFileImport, faThumbsDown, faFilePdf, faFileWord } from '@fortawesome/free-solid-svg-icons';
import { SiMicrosoftexcel } from 'react-icons/si';
import { jsPDF } from "jspdf";
import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, BorderStyle, HeadingLevel, WidthType } from "docx";
import { logEvent } from '../../cloudwatchLogger';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useMediaQuery } from '@mui/material';
import '../../styles.css'



const LogoAndText = () => {
  return (
    <div style={{
      display: 'flex',
      padding: '50px 10px',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: '5px',
      flex: '1 0 0',
      alignSelf: 'stretch',
    }}>
      <img 
        src="Logoicon.png" 
        alt="Logo and Text" 
        style={{
          width: '35px',
        }}
      />
    </div>
  );
};

const CurrentConversation = ({toggleSidebar }) => {
  const [editingId, setEditingId] = useState(null);
  const [editedText, setEditedText] = useState("");
  const conversation = useRecoilValue(conversationState);
  const setConversation = useSetRecoilState(conversationState);
  const [tableLoading, setTableLoading] = useRecoilState(tableLoadingState);
  //console.log('conversation in current conversation: '+conversation.length);
  const [isRegenerating, setIsRegenerating] = useState(null);
  const [isRegeneratingThumbsDown, setIsRegeneratingThumbsDown] = useState(null);
  const [isExporting, setIsExporting] = useState(null);
  const [notification, setNotification] = useState("");
  const conversationContainerRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  
 // const setLogEvents = useSetRecoilState(logEventsState);
 
  const scrollToBottom = () => {
    if (conversationContainerRef.current) {
      conversationContainerRef.current.scrollTop = conversationContainerRef.current.scrollHeight;
    }
  };
 
  useEffect(() => {
    scrollToBottom();
  }, [conversation]);


  const handleThumbsDown = async (id) => {
    setIsRegeneratingThumbsDown(id);
    
    try {
      const originalPrompt = conversation.find(chat => chat.id === id).question;
      
      const response = await fetch("https://nhbli32qjd.execute-api.us-east-1.amazonaws.com/c-valenta/c-valenta", {
        method: 'POST',
        body: JSON.stringify({ user_prompt: originalPrompt }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error('Failed to regenerate response');
      }
  
      const data = await response.json();
  
      const updatedConversation = conversation.map(chat => {
        if (chat.id === id) {
          return { 
            ...chat, 
            response: data, 
            date: new Date().toISOString()  // Update the timestamp
          };
        }
        return chat;
      });
      setConversation(updatedConversation);
      
      logEvent({ eventType: 'thumbsDownRegenerate', details: `Response regenerated for question ID: ${id}` });
      
      //showNotification("Response regenerated successfully!");
    } catch (error) {
      console.error('Failed to regenerate response:', error);
      //showNotification(`Failed to regenerate: ${error.message}`);
    } finally {
      setIsRegeneratingThumbsDown(null);
    }
  };
  
  if(tableLoading) {
    return (
      <div className="flex justify-center items-center h-screen mt-10">
        <div className='relative'>
          <img
            src="update_table_loader.svg"
            alt="Loading..."
            style={{
              width: '869px',
              height: '434px'
            }}
          />
        </div>
      </div>
    );
  };
  

  const getFormattedDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
  };

  const handleEdit = (id) => {
    const chatToEdit = conversation.find(chat => chat.id === id);
    setEditingId(id);
    setEditedText(chatToEdit.question);
  };

  const handleSaveEdit = async (id, newText) => {
    const originalChat = conversation.find(chat => chat.id === id);

    if (originalChat.question === newText) {
      //showNotification("No changes were made. Nothing to save.");
      setEditingId(null);
      return;
    }

    setIsLoading(true);

    try {
      const updatedConversation = conversation.map(chat =>
        chat.id === id
          ? { ...chat, question: newText, date: new Date().toISOString() }
          : chat
      );
      setConversation(updatedConversation); 

        const response = await fetch("https://kjizki5vga.execute-api.us-east-1.amazonaws.com/text2sql/text2sql", {
        method: 'POST',
        body: JSON.stringify({ user_prompt: newText }),
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to regenerate response');
      }

      const data = await response.json();

      const updatedConversationWithResponse = updatedConversation.map(chat =>
        chat.id === id
          ? { ...chat, response: data, date: new Date().toISOString() }
          : chat
      );
      setConversation(updatedConversationWithResponse);

      // showNotification("Response regenerated successfully!");
      logEvent({ eventType: 'editAndRegenerate', details: `Response regenerated for question ID: ${id}` });
    } catch (error) {
      console.error('Failed to regenerate response:', error);
      // showNotification(`Failed to regenerate: ${error.message}`);
    } finally {
      setIsLoading(false);
      setEditingId(null);
    }
  };

 
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; s.length > i; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };
 
  const sanitizeFileName = (name) => {
    return name.replace(/[<>:"\/\\|?*]/g, "_");
  };
  //console.log('conversations is : '+JSON.stringify(conversation));
// h-[325px]
  const scrollbarClasses = `
  
  overflow-auto 
  
  /* Hide scrollbar by default */
  [&::-webkit-scrollbar]:w-0
  hover:[&::-webkit-scrollbar]:w-2
  
  /* Smooth transition */
  [&::-webkit-scrollbar]:transition-[width]
  [&::-webkit-scrollbar]:duration-500
  [&::-webkit-scrollbar]:ease-in-out
  
  /* Thumb and track styles */
  [&::-webkit-scrollbar-thumb]:bg-white
  [&::-webkit-scrollbar-thumb]:rounded-full 
  [&::-webkit-scrollbar-track]:bg-gray-100
  
  /* Hide scrollbar buttons/arrows */
  [&::-webkit-scrollbar-button]:hidden
  [&::-webkit-scrollbar-button]:h-0
  [&::-webkit-scrollbar-button]:w-0
  
  /* Firefox support */
  scrollbar-none
  hover:scrollbar-thin 
  scrollbar-thumb-gray-400 
  scrollbar-track-gray-100
`;
 //console.log('conversation is: '+j)
  return (
    <>
      {conversation.length === 0 ? (
        <img src="update_table_loader.svg" alt="Empty conversation" />
      ) : (
        conversation.slice().map((chat, index) => (
          <Fragment key={chat.id}>
            <ConversationCard
              chat={chat}
              isResponse={false}
              isEditing={editingId === chat.id}
              editedText={editedText}
              onEdit={() => handleEdit(chat.id)}
              onChange={(e) => setEditedText(e.target.value)}
              onSave={() => handleSaveEdit(chat.id, editedText)}
              isLoading={isLoading}
            />
            <ConversationCard
              chat={chat}
              isResponse={true}
              onSave={(newText) => handleSaveEdit(chat.id, newText)}
            />
          </Fragment>
        ))
      )}
    
    </>
    

  );
};

export default CurrentConversation;
